import { CAvatar, CButton, CCard, CCardBody, CCol, CContainer, CFooter, CRow } from '@coreui/react'
import { MedicalInformation } from '@mui/icons-material'
import React from 'react'
import avatar8 from './../../assets/images/avatars/logo1.jpg'
import logo from './../../assets/images/avatars/logo3.png'
import { motion } from 'framer-motion'

import { Link } from 'react-router-dom'
const Homepage = () => {
    const services = [
        {
            title: 'Notes',
            description:
                'Accurate and detailed patient record documentation following standards.',
            icon: MedicalInformation
        },
    ]
    return (
      <div>
        <div className="min-h-screen">
          {/* Navigation */}
          <nav
            className="navbar navbar-expand-lg"
            style={{
              backgroundColor: 'var(--ui-bg-header)',
              borderBottom: '1px solid var(--ui-border-header)',
              boxShadow: 'var(--ui-shadow-sm)',
              minHeight: '70px',
            }}
          >
            <div className="container" style={{ maxWidth: '100%', paddingLeft: '30px', paddingRight: '30px' }}>
              <div className="d-flex align-items-center gap-1">
                <div style={{ width: '4rem', marginLeft: '-20px' }}>
                  <img
                    src={logo}
                    alt="Provio Solutions Logo"
                    style={{ width: '64px', height: '64px', objectFit: 'contain', background: 'transparent' }}
                  />
                </div>
                <span style={{ color: '#4FC3F7', fontSize: '18px', fontWeight: 600, padding: '0 0px', letterSpacing: '0' }}>
                  Provio Solutions
                </span>
              </div>

              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ms-auto align-items-lg-center" style={{ gap: '14px' }}>
                  <li className="nav-item">
                    <a className="nav-link" href="#services" style={{ color: 'var(--ui-text-muted)', fontWeight: 600 }}>
                      Services
                    </a>
                  </li>
                  {/* <li className="nav-item">
                                    <a className="nav-link" href="#about">Career</a>
                                </li> */}
                  <li className="nav-item pl-4 ml-2">
                    <Link to="/login">
                      <CButton color="primary" className="px-4" style={{ fontWeight: 600, borderRadius: '6px' }}>
                        Login
                      </CButton>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          {/* Hero Section */}
          <section
            style={{
              minHeight: '320px',
              padding: '28px 0 54px',
              backgroundColor: 'var(--ui-dashboard-bg)',
            }}
          >
            <CContainer style={{ maxWidth: '100%', paddingLeft: '30px', paddingRight: '30px' }}>
              <CRow className="align-items-center">
                <CCol lg={8} xl={7} className="text-center text-lg-start mb-3 mb-lg-0">
                  <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: 'easeOut' }}
                    style={{
                      maxWidth: '720px',
                      padding: '1rem 0',
                    }}
                  >
                    <div style={{ color: 'var(--ui-color-primary)', fontWeight: 500, marginBottom: '12px', fontSize: '0.9rem' }}>
                      Healthcare Documentation Support
                    </div>
                    <h2 className="fw-semibold mb-3" style={{ fontSize: '2.45rem', lineHeight: 1.15, color: 'var(--ui-text-header-strong)', letterSpacing: '0' }}>
                      Professional Note-Making Services
                    </h2>
                    <p className="mb-4" style={{ color: 'var(--ui-text-secondary)', fontSize: '1.08rem', lineHeight: 1.65, maxWidth: '640px' }}>
                      Streamline your documentation with our expert note-taking — accurate, timely, and fully compliant.
                    </p>
                    <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center justify-content-lg-start">
                    
                        <Link to="/login">
                         
                          <CButton color="primary" size="md" className="px-3">
                        
                            Login
                          </CButton> 
                        </Link>
                      
                      <CButton color="outline-primary" size="md" className="px-3">
                        Learn More
                      </CButton>
                    </div>
                  </motion.div>
                </CCol>
              </CRow>
            </CContainer>
          </section>

          {/* Services Section */}
          <section id="services" style={{ backgroundColor: 'var(--ui-bg-app)', padding: '34px 0 26px' }}>
            <CContainer style={{ maxWidth: '100%', paddingLeft: '30px', paddingRight: '30px' }}>
              {/* Heading */}
              <div className="text-center mb-3">
                <h2 className="fw-bold" style={{ fontSize: '1.65rem', color: 'var(--ui-text-header-strong)' }}>
                  Our Services
                </h2>
                <p style={{ color: 'var(--ui-text-muted)', maxWidth: '40rem', margin: '0 auto', fontSize: '0.95rem' }}>
                  Professional, timely, and reliable documentation solutions tailored to your needs
                </p>
              </div>

              <CRow className="justify-content-center">
                <CCol sm={8} md={5} lg={3} className="d-flex align-items-center justify-content-center">
                  <CCard
                    className="w-100 border-0"
                    style={{
                      maxWidth: '280px',
                      minHeight: '330px',
                      borderRadius: '18px',
                      background: 'var(--ui-bg-card)',
                      boxShadow: 'var(--ui-shadow-md)',
                      overflow: 'hidden',
                    }}
                  >
                    <CCardBody className="d-flex flex-column align-items-center text-center" style={{ padding: '22px 22px 24px' }}>
                      <div
                        className="w-100 d-flex align-items-center justify-content-center mb-3"
                        style={{
                          minHeight: '120px',
                          borderRadius: '14px',
                          background: 'var(--ui-dashboard-surface-3)',
                          position: 'relative',
                        }}
                      >
                        <div style={{ position: 'absolute', top: '25px', left: '47px', width: '64px', height: '49px', borderRadius: '10px', background: 'rgb(31, 158, 231)', opacity: 0.9 }} />
                        <div style={{ position: 'absolute', top: '45px', left: '60px', width: '46px', height: '4px', borderRadius: '999px', background: '#ffffff', opacity: 0.85 }} />
                        <div style={{ position: 'absolute', top: '58px', left: '60px', width: '36px', height: '4px', borderRadius: '999px', background: '#ffffff', opacity: 0.7 }} />
                        <div style={{ position: 'absolute', right: '47px', bottom: '26px', width: '74px', height: '50px', borderRadius: '10px', background: 'rgb(50, 31, 219)', opacity: 0.88 }} />
                        <div style={{ position: 'absolute', right: '57px', bottom: '53px', width: '54px', height: '4px', borderRadius: '999px', background: '#ffffff', opacity: 0.85 }} />
                        <div style={{ position: 'relative', width: '54px', height: '54px', borderRadius: '50%', backgroundColor: 'var(--ui-bg-elevated)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: 'var(--ui-shadow-sm)' }}>
                          <MedicalInformation style={{ width: '28px', height: '28px', color: 'var(--ui-color-primary)' }} />
                        </div>
                      </div>
                      <h3 className="fw-bold mb-2" style={{ color: 'var(--ui-text-header-strong)', fontSize: '1.25rem' }}>
                        {services[0].title}
                      </h3>
                      <p className="mb-3" style={{ color: 'var(--ui-text-secondary)', fontSize: '0.88rem', lineHeight: 1.5, maxWidth: '220px' }}>
                        {services[0].description}
                      </p>
                      <CButton color="primary" size="sm" className="mt-auto px-4" style={{ borderRadius: '999px', fontWeight: 400, letterSpacing: '1.2px' }}>
                      MORE
                      </CButton>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CContainer>
          </section>

          {/* Footer */}
          <CFooter className="py-3" style={{ backgroundColor: 'var(--ui-bg-footer)', borderTop: '1px solid var(--ui-border-color)' }}>
            <CContainer style={{ maxWidth: '100%', paddingLeft: '30px', paddingRight: '30px' }}>
              <CRow className="align-items-center">
                <CCol md={12} className="text-center text-md-end">
                  <Link to="/privacy-policy" style={{ color: 'var(--ui-text-muted)', fontWeight: 500, textDecoration: 'none' }}>
                    Privacy Policy
                  </Link>
                </CCol>
              </CRow>
            </CContainer>
          </CFooter>
        </div>
      </div>
    )
}

export default Homepage
